import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalLayout({ title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-white" data-testid={testid}>
      {/* Header */}
      <header className="border-b border-slate-200 sticky top-0 bg-white/90 backdrop-blur z-10">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-1.5" data-testid="legal-home-link">
            <img src="/operamind-mark.png" alt="OperaMind" className="h-7 w-7 object-contain" />
            <span className="font-heading font-bold text-slate-900">Opera<span className="text-blue-600">Mind</span></span>
          </Link>
          <nav className="flex items-center gap-5 text-sm text-slate-500">
            <Link to="/privacy" className="hover:text-slate-900 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-slate-900 transition-colors">Terms</Link>
            <Link to="/login" className="hover:text-slate-900 transition-colors">Sign in</Link>
          </nav>
        </div>
      </header>

      {/* Body */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 transition-colors mb-6" data-testid="legal-back-link">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">{title}</h1>
        {updated && <p className="text-sm text-slate-400 mt-3">Last updated: {updated}</p>}
        <div className="legal-prose mt-8 space-y-6 text-slate-600 leading-relaxed">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 mt-8">
        <div className="max-w-3xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} OperaMind — AI Workforce Platform.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-slate-900 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-slate-900 transition-colors">Terms of Service</Link>
            <a href="mailto:admin@operamind.uk" className="hover:text-slate-900 transition-colors">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export function Section({ heading, children, id }) {
  return (
    <section id={id}>
      <h2 className="font-heading text-xl font-bold text-slate-900 tracking-tight">{heading}</h2>
      <div className="mt-3 space-y-3">{children}</div>
    </section>
  );
}
